import { gql } from "@apollo/client";

export const GET_ONLINE_STATUS = gql`
  query getOnlineStatus {
    getOnlineStatus
  }
`;

export const GET_REIN_USERS = gql`
  query getReinUsers {
    getReinUsers {
      id
      username
      cbUsername
      discordProfile
      discordTokens
      discordLinkedAt
      createdAt
      lifetimeTips
      inFanclub
    }
  }
`;

export const GET_COMMUNITY_TIPPERS = gql`
  query getCommunityTippers(
    $search: String
    $inFanclub: Boolean
    $linked: Boolean
    $sort: String
    $limit: Int
  ) {
    getCommunityTippers(
      search: $search
      inFanclub: $inFanclub
      linked: $linked
      sort: $sort
      limit: $limit
    ) {
      tippers {
        id
        username
        lifetimeTips
        lifetimeBiggestTip
        inFanclub
        lastSeen
        reinUserId
        reinUsername
        crimcoins
        hasDiscord
      }
      total
      totalTippers
      inFanclubCount
      linkedCount
    }
  }
`;

export const GET_HYDRATION_TIPS = gql`
  query getHydrationTips {
    getHydrationTips {
      amount
      createdAt
      description
      type
    }
  }
`;

// Returns the row with the same fields as getReinUsers, so the cached list
// updates in place.
export const UNLINK_USER_CHATURBATE = gql`
  mutation UnlinkUserChaturbate($userId: ID!) {
    unlinkUserChaturbate(userId: $userId) {
      id
      username
      cbUsername
      discordProfile
      discordTokens
      discordLinkedAt
      createdAt
      lifetimeTips
      inFanclub
    }
  }
`;

export const GET_TIPPER_PROFILE = gql`
  query getTipperProfile($cbUsername: String!) {
    getTipperProfile(cbUsername: $cbUsername) {
      tipperId
      cbUsername
      inFanclub
      isVip
      grantUntil
      lastSeen
      firstJoinedFanclub
      lastFanclubEnded
      lifetimeTips
      lifetimeBiggestTip
      numberOfTips
      chips
      reinUserId
      reinUsername
      crimcoins
      discordLinkSource
      discordName
      tipCounts {
        amount
        count
        itemName
      }
      recentTips {
        id
        tokens
        message
        itemName
        createdAt
      }
    }
  }
`;
